// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__3rySN","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__2ybZg"};